const accordion = () => {
    const accordions    = document.querySelectorAll('[data-accordion="accordion"]');
    let activeAccordion = null;

    accordions.forEach((el) => {
        el.addEventListener('click', (e) => {
            const self    = e.currentTarget;
            const control = self.querySelector('[data-accordion="control"]');
            const content = self.querySelector('[data-accordion="content"]');

            if (self === activeAccordion) {
                self.classList.remove('open');
                control.setAttribute('aria-expanded', 'false');
                content.setAttribute('aria-hidden', 'true');
                activeAccordion = null;


                self.querySelectorAll('[data-accordion="text"]').forEach((element) => element.classList.remove('active'));
            } else {
                if (activeAccordion) {
                    const activeControl = activeAccordion.querySelector('[data-accordion="control"]');
                    const activeContent = activeAccordion.querySelector('[data-accordion="content"]');
                    activeAccordion.classList.remove('open');
                    activeControl.setAttribute('aria-expanded', 'false');
                    activeContent.setAttribute('aria-hidden', 'true');


                    activeAccordion.querySelectorAll('[data-accordion="text"]').forEach((element) => element.classList.remove('active'));
                }

                self.classList.add('open');
                control.setAttribute('aria-expanded', 'true');
                content.setAttribute('aria-hidden', 'false');

                activeAccordion = self;

                setTimeout(() => {

                    self.querySelectorAll('[data-accordion="text"]').forEach((element) => element.classList.add('active'));
                }, 400);

                el.querySelector('[data-accordion="content"]').addEventListener('click', (e) => {
                    e.stopPropagation();
                });
            }
        });
    });
};

export default accordion;
